import React from "react";
import { FixedFeeConfig } from "@amzn/fuse-accounting-central-datastore-client";

interface Props {
  fixedFeeConfig: FixedFeeConfig;
}

export const FixedFeeConfigDisplay: React.FC<Props> = ({ fixedFeeConfig }) => {
  return (
    <pre className="sourceInfo">{JSON.stringify(fixedFeeConfig, null, 2)}</pre>
  );
};
